import { EventEmitter, OnInit } from '@angular/core';
var ItauModalComponent = /** @class */ (function () {
    function ItauModalComponent() {
        this.close = new EventEmitter();
    }
    ItauModalComponent.prototype.ngOnInit = function () {
    };
    ItauModalComponent.prototype.closeModal = function () {
        this.close.emit(true);
    };
    return ItauModalComponent;
}());
export { ItauModalComponent };
